import { motion } from "framer-motion";
import { whatsapp } from "./data";

const Icon = () => (
  <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.93.95-3.48-.22-.36a9.43 9.43 0 1 1 7.99 4.42zm8.02-17.45A11.27 11.27 0 0 0 12.05.75C5.8.75.72 5.83.72 12.08c0 2 .52 3.95 1.52 5.66L.62 23.25l5.65-1.48a11.3 11.3 0 0 0 5.78 1.47h.01c6.24 0 11.33-5.08 11.33-11.33 0-3.03-1.18-5.87-3.32-8.01z" />
  </svg>
);

export const WhatsAppButton = () => (
  <motion.a
    href={whatsapp("Ciao Pellet Italiana, vorrei un preventivo per il pellet in vero legno di abete.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Richiedi preventivo su WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.95 }}
    className="group fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center gap-3 rounded-full bg-[#25D366] text-[#0B2A17] p-3.5 sm:pr-6 shadow-[0_12px_40px_rgba(0,0,0,0.35)]"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 pointer-events-none" />
    <Icon />
    <span className="hidden sm:flex flex-col leading-tight relative">
      <span className="text-[11px] uppercase tracking-[0.16em] font-bold">Preventivo</span>
      <span className="text-sm font-semibold">su WhatsApp</span>
    </span>
  </motion.a>
);
